import React from 'react';
import Container from './common/Container';
import Row from './common/Row';

const Footer = () => {
    return (
        <footer className="mt-16 bg-slate-950">
        <Container className="py-8">
            <Row className="items-center justify-between gap-4 text-sm text-slate-400">
                <p>© {new Date().getFullYear()} NovaMarket. Built for better browsing.</p>
                <p className="font-medium text-slate-300">Secure checkout • Curated products</p>
            </Row>
        </Container>
        </footer>
    );
};

export default Footer;
